import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import contentImage41 from "../../assets/contentImg41.png";
import contentImage43 from "../../assets/contentImg43.png";
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";
import image4 from "../../assets/image4.png";
import image22 from "../../assets/image22.png";
import image71 from "../../assets/image71.jpg";
import image72 from "../../assets/image72.jpg";
import image73 from "../../assets/image73.jpg";
import image74 from "../../assets/image74.jpg";
import image75 from "../../assets/image75.jpg";
import image76 from "../../assets/image76.jpg";
import image77 from "../../assets/image77.jpg";
import imagenew21 from "../../assets/imagenew21.png";
import resource1 from "../../assets/resources1.jpeg";
import resource2 from "../../assets/resources2.jpeg";
import resource3 from "../../assets/resources3.png";
import resource4 from "../../assets/resources4.png";
import { Link, useNavigate } from "react-router-dom";

import leadQualification from "../../assets/Lead_Qualification.mp3";
import renewal from "../../assets/insurance_renewal.mp3";
import scheduling from "../../assets/scheduling.mp3";
import nps from "../../assets/NPS.mp3";

import PlayIcon from "../../assets/PlayIcon";
import CircularWavePattern from "../../components/CircularWavePattern";
import CustomAudioPlayer from "../../components/CustomAudioPlayer";
import BajajAutoLogo from "../../assets/BajajAutoLogo";
import SnapmintLogo from "../../assets/SnapmintLogo";
import LittleItalyLogoPng from "../../assets/LittleItalyLogo.png";
import AdityaBirlaLogo from "../../assets/AdityaBirlaLogo.webp";
import { getAllBlogs } from "../../services/blogService";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";
import PiramalLogo from "../../assets/PiramalLogo";
import Kotak_Life_Insurance_Logo from "../../assets/Kotak_Life_Insurance_Logo.png";
import AB_Health_Logo from "../../assets/AB_Health_Logo.png";

const HomePage = () => {
  const navigate = useNavigate();

  const BG_COLOR_CLASS_HOMEPAGE_SECTION_ONE = "bg-[#010021]";

  const DARK_PURPLE_BORDER_COLOR_CLASS = "border-[#010021]";
  const DARK_PURPLE_THEME_COLOR = "#010021";

  const [showVideo, setShowVideo] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  const audioRef = useRef(null);
  const audioDemos = useMemo(
    () => [
      { name: "Finance Lead Qualification Demo", src: leadQualification },
      { name: "Insurance Renewal Demo", src: renewal },
      { name: "Physical Visit Scheduling Demo", src: scheduling },
      { name: "Net Promoter Score Demo", src: nps },
    ],
    []
  );

  // demo slider
  const [currentDemoIndex, setCurrentDemoIndex] = useState(0);

  const goToNext = () => {
    setCurrentDemoIndex((prevIndex) =>
      prevIndex === audioDemos.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrev = () => {
    setCurrentDemoIndex((prevIndex) =>
      prevIndex === 0 ? audioDemos.length - 1 : prevIndex - 1
    );
  };

  const [activeUsecase, setActiveUsecase] = useState("inbound");

  // testimonial

  const TESTIMONIALS = [
    {
      id: 1,
      content: [
        "At Bajaj Auto, a brand synonymous with innovation and excellence, we are always on the lookout for technologies that can enhance customer experience while aligning with our reputation and Brand. Partnering with SalesAgents AI to deploy their AI-powered voicebot for sales and test drive bookings has been successful for us.",
        "The seamless integration of the voicebot into our existing systems, executed in record time by the capable team at SalesAgents AI, was truly impressive. The AI-driven conversations have been flawless, mirroring the professionalism and precision that customers expect from the Bajaj Auto brand. The voicebot has not only improved engagement with our customers but also exceeded our expectations in terms of conversions for both sales inquiries and test drive bookings.",
        "The product was proudly showcased at our recent leadership retreat, where it was unanimously acknowledged as a significant step forward in enhancing customer interactions and leveraging AI for business growth. The collaboration with SalesAgents AI has been an outstanding success, and we look forward to exploring further possibilities together.",
      ],

      author: "Rizwan Deshmukh",
      designation: "Marketing Manager",
      company: "Bajaj Auto",
    },
    {
      id: 2,
      content: [
        "We have been working with SalesAgents AI for almost a year now. We could completely remove the internal calling effort for inviting our guests to celebrate their Anniversaries with us, with LISA (Little Italy Sales Agent). The team does a great job in getting daily table booking across our chain of restaurants. We have started expanding this recently to our non owned, franchise outlets as well. Highly recommend the team behind SalesAgents AI to any business looking to scale their sales.",
      ],

      author: "Lojo Karathra",
      designation: "CEO",
      company: "Little Italy Chain of restaurants",
    },
  ];

  const TESTIMONIALS_2 = [
    {
      id: 1,
      content: `The AI-driven conversations have been flawless, mirroring the professionalism and precision that customers expect from the Bajaj Auto brand.`,
      author: "Rizwan Deshmukh, Marketing Manager, Bajaj Auto",
    },
    {
      id: 2,
      content:
        "The team does a great job in getting daily table booking across our chain of restaurants.",
      author: "Lojo Karathra, CEO, Little Italy Chain of restaurants",
    },
    {
      id: 3,
      content: `The voicebot has not only improved engagement with our customers but also exceeded our expectations in terms of conversions for both sales inquiries and test drive bookings.`,
      author: "Rizwan Deshmukh, Marketing Manager, Bajaj Auto",
    },
    {
      id: 4,
      content:
        "Highly recommend the team behind SalesAgents AI to any business looking to scale their sales.",
      author: "Lojo Karathra, CEO, Little Italy Chain of restaurants",
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const goToNextTestimonial = useCallback(() => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === TESTIMONIALS.length - 1 ? 0 : prevIndex + 1
    );
  }, [TESTIMONIALS.length]);
  const goToPrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? TESTIMONIALS.length - 1 : prevIndex - 1
    );
  };

  // const sliderInterval = useRef(null);

  // useEffect(() => {
  //   sliderInterval.current = setInterval(() => {
  //     goToNextTestimonial();
  //   }, 60000);

  //   return () => {
  //     clearInterval(sliderInterval.current);
  //   };
  // }, [goToNextTestimonial]);

  // Fetch all blogs
  const [blogs, setBlogs] = useState([]);
  const [blogsLoading, setBlogsLoading] = useState(false);

  const fetchAllBlogsAsync = async () => {
    setBlogsLoading(true);
    const res = await getAllBlogs();
    setBlogs(res?.data);
    setBlogsLoading(false);
  };

  useEffect(() => {
    fetchAllBlogsAsync();
  }, []);

  const RESOURCES = [
    {
      id: 1,
      title: "How to Prompt your SALESAGENTAI phone call agent",
      date: "September 27 2023",
      img: resource1,
    },
    {
      id: 2,
      title: "The Comprehensive Guide to AI Phone Calling",
      date: "September 27 2023",
      img: resource2,
    },
    {
      id: 3,
      title: "How to Prompt your SALESAGENTAI phone call agent",
      date: "September 27 2023",
      img: resource3,
    },
    {
      id: 4,
      title: "How to build and appointment scheduler with Zapier",
      date: "September 27 2023",
      img: resource4,
    },
  ];

  const getBlogPhoto = (resource_index) => {
    const index = resource_index % 4;
    if (index === 0) {
      return resource1;
    }
    if (index === 1) {
      return resource2;
    }
    if (index === 2) {
      return resource3;
    }
    if (index === 3) {
      return resource4;
    }
  };

  return (
    <div>
      <div className={`min-h-[90vh] ${BG_COLOR_CLASS_HOMEPAGE_SECTION_ONE}`}>
        <div
          className={`flex flex-col sm:flex-row gap-10 sm:gap-20 px-4 sm:px-16 sm:pt-12 pb-12 sm:pb-0`}>
          <div className={`w-full sm:w-1/2`}>
            <div className="flex flex-col sm:flex-row items-center">
              {/* <Link to={`blogs/blog/${blogs[0]?.id}`}> */}
              <div className="cursor-pointer text-[#FFB1B1] bg-[#33324D] rounded-full mt-4 sm:mt-0 mb-0 sm:mb-6 py-2 px-8 text-center sm:text-left flex gap-2 justify-center">
                <div className="text-inherit text-center sm:text-left">
                  Explore how we helped Bajaj
                </div>
                <RightArrowIcon />
              </div>
              {/* </Link> */}
            </div>

            <div className="text-[#CDCBFF] text-5xl leading-[3.5rem] sm:text-6xl sm:leading-none text-center sm:text-left pt-6 sm:pt-0 sm:mt-[0px]  tracking-tight">
              AI sales scaling with top 20% salesreps conversions
            </div>
            <div className="text-[#CDCBFF] pt-6 sm:pt-8 text-base text-xl sm:text-2xl sm:w-[90%] text-center sm:text-left">
              Global first in pitching and persuasive AI for insurance sales
            </div>
            <div className="mt-12 sm:mt-12 font-medium text-center sm:text-left">
              <button
                className="bg-white px-5 py-3.5 rounded"
                onClick={() => {
                  navigate("/joinwaitlist");
                }}>
                Contact Us
              </button>
            </div>
          </div>
          <div className={`w-full sm:w-1/2 flex flex-col items-center`}>
            {!!!showVideo && (
              <div className="bg-[#33324D] aspect-video w-[85vw] sm:w-[30rem] mt-4 sm:mt-0 mb-8 sm:mb-8 rounded-2xl flex items-center justify-center">
                <div className="flex flex-col gap-2 items-center pt-6">
                  <div
                    onClick={() => {
                      setShowVideo((prev) => !prev);

                      audioRef.current.play(); // Play the video
                      setIsAudioPlaying(true);
                    }}
                    className="flex items-center justify-center rounded-full border border-white w-16 h-16 cursor-pointer hover:border-[#CDCBFF]">
                    <PlayIcon />
                  </div>
                  <div className="text-[#cdcbff]">watch a demo</div>
                </div>
              </div>
            )}

            {audioDemos[currentDemoIndex] && (
              <div
                className={`bg-[#33324D] aspect-video w-[85vw] sm:w-[30rem] mt-4 sm:mt-0 mb-8 sm:mb-8 rounded-2xl flex items-center justify-center ${!!!showVideo && "hidden"
                  }`}>
                <div className="flex flex-col gap-2 items-center p-3">
                  <CircularWavePattern
                    audioElement={audioRef.current}
                    showVideo={showVideo}
                  />
                  <CustomAudioPlayer
                    isAudioPlaying={isAudioPlaying}
                    setIsAudioPlaying={setIsAudioPlaying}
                    audioRef={audioRef}
                    src={audioDemos[currentDemoIndex].src}
                    currentDemoIndex={currentDemoIndex}
                  />
                </div>
              </div>
            )}

            <div className="text-purple-200 text-center mb-4 text-lg">
              {audioDemos[currentDemoIndex].name}
            </div>

            {
              <div className="flex justify-center gap-2">
                <div
                  onClick={goToPrev}
                  className="text-[#CDCBFF] p-2 border-[2px] border-transparent transition-colors hover:border-[2px] hover:border-[#CDCBFF] rounded-full cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="#CDCBFF"
                    className="text-[#CDCBFF] w-6 h-6">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 19.5 8.25 12l7.5-7.5"
                    />
                  </svg>
                </div>
                <div
                  onClick={goToNext}
                  className={`text-[#CDCBFF] p-2 border-[2px] border-transparent transition-colors hover:border-[2px] hover:border-[#CDCBFF] rounded-full cursor-pointer`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="#CDCBFF"
                    className="text-[#CDCBFF] w-6 h-6">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m8.25 4.5 7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </div>
              </div>
            }
            {/* <div className="relative group">

              <div
                className={`w-40 h-40 rounded-full border-4 border-violet-300 ${
                  isAudioPlaying ? "animate-random-wave" : ""
                } transition-transform duration-500 ease-in-out shadow-lg`}
              />

              <div
                className={`absolute top-0 left-0 w-40 h-40 rounded-full border-2 border-blue-300 opacity-50 shadow-lg ${
                  isAudioPlaying ? "animate-glow-wave" : ""
                }`}
              />
            </div> */}
          </div>
        </div>
        <div className="text-center text-[#E1E3E3] px-4 sm:px-0 text-2xl pb-16 sm:pb-6 pt-0 sm:pt-10">
          SalesAgents AI powers top business houses and leaders in the Industry.
        </div>
        {/* class for divider if required below: divide-[#BAC4C033] */}
        <div className="overflow-hidden pb-10">
          <div className="flex items-center w-[180rem] animate-marquee-infinite">
            <div className="flex items-center justify-around basis-full grow-0 shrink-0">
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white">
                <BajajAutoLogo />
              </div>
              <div className="w-[15rem] px-4 pb-3 flex justify-center text-white">
                <PiramalLogo />
              </div>
              <div className="px-[2.5rem] w-[15rem]">
                <div className="w-[10rem] h-[4.2rem]  flex justify-center items-center text-white text-center text-nowrap bg-white rounded-sm">
                  <img
                    className="w-32 h-14 object-contain"
                    src={AB_Health_Logo}
                    alt="Aditya Birla Health Insurance Logo"
                  />
                </div>
              </div>
              <div className="px-[2.5rem] w-[15rem]">
                <div className="w-[10rem] h-[4.2rem] py-2 flex justify-center items-center bg-white rounded-sm">
                  <img
                    className="w-32 h-14 object-contain"
                    src={Kotak_Life_Insurance_Logo}
                    alt="Kotak Life Insurance Logo"
                  />
                </div>
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white">
                <SnapmintLogo />
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white">
                <img
                  className="w-32 h-14"
                  src={LittleItalyLogoPng}
                  alt="Little Italy Logo"
                />
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Listed NBFC Aggregator
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top NBFCs
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top Health Insurance Businesses
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top Life Insurance Businesses
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top General Insurance Businesses
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                #1 Global BPO
              </div>
            </div>
            <div className="flex items-center justify-around basis-full grow-0 shrink-0">
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white">
                <BajajAutoLogo />
              </div>
              <div className="w-[15rem] px-4 pb-3 flex justify-center text-white">
                <PiramalLogo />
              </div>
              <div className="px-[2.5rem] w-[15rem]">
                <div className="w-[10rem] h-[4.2rem] py-0 flex justify-center items-center text-white text-center text-nowrap bg-white rounded-sm">
                  <img
                    className="w-32 h-14 object-contain"
                    src={AB_Health_Logo}
                    alt="Aditya Birla Health Insurance Logo"
                  />
                </div>
              </div>
              <div className="px-[2.5rem] w-[15rem]">
                <div className="w-[10rem] h-[4.2rem] py-2 flex justify-center items-center bg-white rounded-sm">
                  <img
                    className="w-32 h-14 object-contain"
                    src={Kotak_Life_Insurance_Logo}
                    alt="Kotak Life Insurance Logo"
                  />
                </div>
              </div>

              <div className="w-[15rem] px-4 py-2 flex justify-center text-white">
                <SnapmintLogo />
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white">
                <img
                  className="w-32 h-14"
                  src={LittleItalyLogoPng}
                  alt="Little Italy Logo"
                />
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Listed NBFC Aggregator
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top NBFCs
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top Life Insurance Businesses
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top Health Insurance Businesses
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                Top General Insurance Businesses
              </div>
              <div className="w-[15rem] px-4 py-2 flex justify-center text-white text-center text-nowrap">
                #1 Global BPO
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-[60px] sm:py-[80px] px-4 sm:px-16">
        <div className="pb-16 sm:pb-24 text-4xl text-center  sm:text-left sm:text-5xl sm:leading-snug w-full sm:w-[80%]">
          Never before seen AI at scale, conversation quality, latency,
          personalization, persuasion, relationship building and sales
          conversions
        </div>
        <div className="flex flex-col sm:flex-row gap-6">
          <div className="sm:w-1/2 bg-[#f3f3f3] h-[433px] rounded-lg p-0 flex flex-col relative">
            <img
              src={image22}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-[28px] font-medium text-white">
                Available 24/7
              </div>
              <div className="font-light text-white">
                Scale up and scale down on demand. No need to hire, train, and
                manage a team of agents.
              </div>
            </div>
          </div>

          <div className="sm:w-1/2 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={imagenew21}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Ultra-realistic voices
              </div>
              <div className="text-white text-[#212124] font-light">
                Choose from a variety of voices to create the perfect experience
                for your customers. Different voices for different customers,
                but always the same voice for same customer, no problem!
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-6 pt-6">
          <div className="sm:w-1/3 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={image74}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Multilingual capability
              </div>
              <div className="text-white font-light">
                Understand and speak different dialects, accents, and languages.
                Switch language basis customer requirement mid conversation, no
                problem!
              </div>
            </div>
          </div>
          <div className="sm:w-1/3 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={image75}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Persuasive AI
              </div>
              <div className="text-white font-light">
                Understand deep down customer needs and intents, and suggest a
                highly personalised plan basis customer requirement. Its all
                about the conversations!
              </div>
            </div>
          </div>
          <div className="sm:w-1/3 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={image76}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Anywhere Anytime Customer Conversations
              </div>
              <div className="text-white font-light">
                Customer conversation where the customer is, be it on website,
                phone calls, messaging platform, emails, social media or
                anywhere else online!
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-6 py-6">
          <div className="sm:w-1/3 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={image71}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Boost salesperson productivity with AI
              </div>
              <div className="text-white font-light">
                The virtual agents can prioritize leads, qualify prospects and
                even engage in initial conversations. Saving salesperson's time
                spent in top of funnel, where drop off is greater than 80-90%
              </div>
            </div>
          </div>
          <div className="sm:w-1/3 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={image72}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Outcomes and cost optimisation
              </div>
              <div className="text-white font-light">
                Sales to cost multiplier (on fixed set of leads) of 4x! Savings
                from 50% plus!
              </div>
            </div>
          </div>
          <div className="sm:w-1/3 bg-[#f3f3f3] h-[433px] rounded-lg flex flex-col relative">
            <img
              src={image73}
              className="object-cover w-full h-full rounded-lg"
              alt=""
            />
            <div className="p-8 bg-[#f3f3f3] absolute top-1/2 transform -translate-y-1/2 text-center bg-black bg-opacity-50 p-4">
              <div className="text-white text-[28px] font-medium">
                Newer use cases
              </div>
              <div className="text-white font-light">
                Was ROI a challenge in expanding business TAM or opening new
                offerings, no more!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-[60px] sm:py-[80px] px-4 sm:px-16 bg-[#8A5D4A]">
        <div className="text-white text-3xl sm:text-[56px] sm:leading-[69px] tracking-[-0.9px] pb-[60px] sm:pb-[80px] sm:pr-32">
          Industry-Tailored Automation: Streamlining Customer Conversations
          Across Financial Services, Automotive, Healthcare, Real Estate,
          Logistics, Ecommerce and Small Businesses
        </div>
        <div className="flex flex-col sm:flex-row gap-6">
          <div className="sm:w-1/3 flex flex-col">
            <div
              onClick={() => {
                setActiveUsecase("inbound");
              }}
              className={`py-3 text-2xl ${activeUsecase === "inbound" ? "text-white" : "text-white/50"
                } cursor-pointer border-y border-[#BAC4C0]/20`}>
              Inbound sales enquiry
            </div>
            <div
              onClick={() => {
                setActiveUsecase("outbound");
              }}
              className={`py-3 text-2xl ${activeUsecase === "outbound" ? "text-white" : "text-white/50"
                } cursor-pointer`}>
              Outbound calls automation
            </div>
            <div
              onClick={() => {
                setActiveUsecase("lead");
              }}
              className={`py-3 text-2xl ${activeUsecase === "lead" ? "text-white" : "text-white/50"
                } cursor-pointer border-y border-[#BAC4C0]/20`}>
              Lead Qualification and Demo setup
            </div>
            {activeUsecase === "inbound" && (
              <div className="mt-auto pt-10 sm:pt-0 pl-10 pr-10 sm:pl-0 sm:pr-32 py-3 text-white text-center sm:text-left">
                The bot will assist with inbound calls and will handle all
                entry-level queries.
              </div>
            )}
            {activeUsecase === "outbound" && (
              <div className="mt-auto pt-10 sm:pt-0 pl-10 pr-10 sm:pl-0 sm:pr-32 py-3 text-white text-center sm:text-left">
                The bot will call make outbound calls at scale with multiple
                concurrent & customised calls for sales, collections, surveys
                and more.
              </div>
            )}
            {activeUsecase === "lead" && (
              <div className="mt-auto pt-10 sm:pt-0 pl-10 pr-10 sm:pl-0 sm:pr-32 py-3 text-white text-center sm:text-left">
                The bot can qualify interested leads and transfer to a human
                agent real time or send a report with the interested leads for
                you to reach out later.
              </div>
            )}

            <div className="pt-3 text-center sm:text-left">
              <button
                className="bg-white px-5 py-2.5 rounded-md font-medium"
                onClick={() => {
                  navigate("/joinwaitlist");
                }}>
                Express Interest
              </button>
            </div>
          </div>
          <div className="sm:w-2/3 aspect-[4/3] rounded-xl bg-white/25 backdrop-blur-xl">
            {activeUsecase === "inbound" && (
              <img
                src={image1}
                className="w-full h-full object-cover rounded-xl"
                alt=""
              />
            )}
            {activeUsecase === "outbound" && (
              <img
                src={image2}
                className="w-full h-full object-cover rounded-xl"
                alt=""
              />
            )}
            {activeUsecase === "lead" && (
              <img
                src={image77}
                className="w-full h-full object-cover rounded-xl"
                alt=""
              />
            )}
          </div>
        </div>
      </div>
      <div className="py-[60px] sm:py-[90px] px-4 sm:px-16">
        <div className="flex flex-col sm:flex-row gap-0 sm:gap-6">
          <div className="flex flex-col gap-6 sm:w-1/2 sm:pr-[200px] ">
            <div className="text-4xl sm:text-[56px] sm:pt-6 leading-[3rem] sm:leading-[69px]">
              Supreme Trust and Safety Assurance
            </div>
            <div className="text-lg font-light leading-[25px] pt-3 sm:pt-0 tracking-[-0.05px]">
              We continue to actively restrict the calls we support, ensuring
              that our AI phone call technology continues to benefit consumers,
              businesses, and society as a whole.
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="mt-auto pt-6 sm:pt-0 flex flex-col justify-between gap-4 sm:gap-4 sm:w-[70%] sm:border-b sm:border-[#1e1e1e]/25">
                <div
                  className={`${BG_COLOR_CLASS_HOMEPAGE_SECTION_ONE} aspect-video flex rounded-lg justify-center items-center`}>
                  <img className="w-64" src={contentImage41} alt="" />
                </div>
                <div className="w-[80%] pb-0 sm:pb-4 text-lg font-light">
                  Certified by Information Security Management 27001
                </div>
              </div>
              <div className="sm:pt-0 flex flex-col justify-between gap-4 sm:gap-4 sm:w-[70%] sm:border-b sm:border-[#1e1e1e]/25">
                <div
                  className={`bg-[#f3f3f3] py-[0.62rem] aspect-video flex rounded-lg justify-center items-center`}>
                  <img className="w-[60%] " src={contentImage43} alt="" />
                </div>
                <div className="w-[80%] pb-0 sm:pb-4 text-lg font-light">
                  SOC 2 Type II Certified
                </div>
              </div>
            </div>
          </div>
          <div className="sm:w-1/2 flex flex-col justify-center image-center mt-8 sm:mt-0">
            <div className="w-full">
              <img src={image4} alt="" />
            </div>
            {/* <div className="py-16 border-y border-[#1e1e1e]/25 flex flex-col gap-6">
              <div className="text-3xl">Call monitoring</div>
              <div className="leading-[25px] tracking-[-0.05px]">
                Some line about call monitoring can go here as shown, can also
                mention how it enhances the safety
              </div>
            </div>
            <div className="py-16 flex flex-col gap-6">
              <div className="text-3xl">Prompt filtering</div>
              <div className="leading-[25px] tracking-[-0.05px]">
                Some line about call monitoring can go here as shown, can also
                mention how it enhances the safety
              </div>
            </div>
            <div className="py-16 border-y border-[#1e1e1e]/25 flex flex-col gap-6">
              <div className="text-3xl">Perioding Audits</div>
              <div className="leading-[25px] tracking-[-0.05px]">
                Some line about call monitoring can go here as shown, can also
                mention how it enhances the safety
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div
        className={`relative py-24 px-6 sm:px-16 ${BG_COLOR_CLASS_HOMEPAGE_SECTION_ONE}`}>
        <div className="flex flex-col items-center text-center h-auto">
          <h2 className="text-[#CDCBFF] text-4xl sm:text-5xl font-semibold mb-[5rem] sm:mb-[7rem]">
            Don't take our word for it. Take theirs
          </h2>

          {/* Floating Testimonial Card */}
          <div className="flex flex-col justify-center sm:h-[35rem] relative max-w-3xl sm:max-w-6xl w-full">
            <div className="absolute inset-0 bg-[#CDCBFF] opacity-20 blur-3xl rounded-full transform scale-110"></div>
            <div className="relative z-10 bg-[#1A1A40] px-10 py-12 rounded-2xl shadow-lg transition-transform duration-500 ease-in-out hover:-translate-y-2">
              {/* Flexbox Layout for Testimonial and Author */}
              <div className="flex flex-col sm:flex-row gap-6 sm:gap-10">
                {/* Author Info */}
                <div className="basis-1/3 text-center mt-2 sm:mt-6 sm:mt-0">
                  <p className="text-gray-300 text-lg sm:text-xl font-semibold">
                    {TESTIMONIALS[currentTestimonialIndex].author}
                  </p>
                  <p className="text-gray-400 text-sm sm:text-base">
                    {TESTIMONIALS[currentTestimonialIndex].designation},{" "}
                    {TESTIMONIALS[currentTestimonialIndex].company}
                  </p>
                </div>
                {/* Testimonial Content */}
                <div className="basis-2/3 text-[#CDCBFF] text-base sm:text-xl italic text-left">
                  {TESTIMONIALS[currentTestimonialIndex].content.map(
                    (para, index) => (
                      <p key={index} className="text-[#CDCBFF] mb-4 last:mb-0">
                        {para}
                      </p>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex mt-6 gap-4 relative">
            <button
              onClick={goToPrevTestimonial}
              className="p-3 border-2 border-[#CDCBFF] rounded-full bg-transparent hover:bg-[#EAE8FF] hover:bg-opacity-20 hover:backdrop-blur-lg hover:text-[#1A1A40] hover:scale-105 transition-all duration-300 ease-in-out cursor-pointer z-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="#CDCBFF"
                className="text-[#CDCBFF] w-6 h-6">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </button>

            <button
              onClick={goToNextTestimonial}
              className="p-3 border-2 border-[#CDCBFF] rounded-full bg-transparent hover:bg-[#EAE8FF] hover:bg-opacity-20 hover:backdrop-blur-lg hover:text-[#1A1A40] hover:scale-105 transition-all duration-300 ease-in-out cursor-pointer z-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="#CDCBFF"
                className="text-[#CDCBFF] hover:text-white w-6 h-6">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="py-[60px] sm:py-[90px] px-4 sm:px-16">
        <div className="text-lg">Resources</div>

        <div className="text-4xl sm:text-[56px] sm:pt-3 leading-[3rem] sm:leading-[69px]">
          Latest Articles
        </div>
        <div className="sm:pt-20 flex flex-col sm:flex-row gap-4 overflow-x-auto">
          {blogs.map((item, index) => {
            console.log(item?.image);
            return (
              // <Link key={item.id} to={`/blogs/blog/${item.id}`}>
              <div className="cursor-pointer sm:w-80 shrink-0">
                <hr />
                <div className="pt-10 font-medium">{item.name}</div>
                <div className="pt-3 text-sm text-[#1e1e1e] tracking-wider uppercase">
                  {new Date(item?.created_at).toDateString()}
                </div>
                <div className="pt-3 w-full aspect-[3/4]">
                  <img
                    src={resource2}
                    className="w-full h-full object-cover rounded-xl"
                    alt=""
                  />
                </div>
              </div>
              // </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
